import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { RatingSuggestion } from "@/utils/ratingSuggestions";

interface RatingSuggestionBannerProps {
  suggestion: RatingSuggestion;
  onApprove: () => void;
  onDismiss: () => void;
  loading?: boolean;
}

const RatingSuggestionBanner = ({
  suggestion,
  onApprove,
  onDismiss,
  loading,
}: RatingSuggestionBannerProps) => {
  const { t } = useTranslation();
  const parts: string[] = [];

  if (suggestion.skills) {
    parts.push(
      t("players.ratingSuggestion.skillsChange", "Skills {{from}} → {{to}}", {
        from: suggestion.skills.from,
        to: suggestion.skills.to,
      })
    );
  }
  if (suggestion.effort) {
    parts.push(
      t("players.ratingSuggestion.effortChange", "Effort {{from}} → {{to}}", {
        from: suggestion.effort.from,
        to: suggestion.effort.to,
      })
    );
  }
  if (suggestion.stamina) {
    parts.push(
      t("players.ratingSuggestion.staminaChange", "Stamina {{from}} → {{to}}", {
        from: suggestion.stamina.from,
        to: suggestion.stamina.to,
      })
    );
  }

  return (
    <div className="rounded-lg border border-soccer-primary/30 bg-soccer-primary/5 p-3 text-sm space-y-2">
      <p className="font-medium">
        {t("players.ratingSuggestion.title", "Suggested rating update")}
      </p>
      <p className="text-muted-foreground">
        {t(
          "players.ratingSuggestion.reason",
          "Based on last {{games}} games ({{wins}}W, {{goals}} goals)",
          suggestion.reasonParams
        )}
      </p>
      <p>{parts.join(" · ")}</p>
      <div className="flex gap-2">
        <Button size="sm" onClick={onApprove} disabled={loading}>
          {t("players.ratingSuggestion.approve", "Approve")}
        </Button>
        <Button size="sm" variant="outline" onClick={onDismiss} disabled={loading}>
          {t("common.dismiss", "Dismiss")}
        </Button>
      </div>
    </div>
  );
};

export default RatingSuggestionBanner;
